import { useState } from "react";
import { ListDropdownMultipleProps } from "@affinitysystemsgroup/github-packages-affinity-components/dist/src/interfaces/interface";
import { useUserGetAll } from "../../../fnx/user/userGetAll";
import { user } from  "../../../store/auth/actions";
import { useDispatch } from "react-redux";

export interface Filters {
    enabled: boolean;
    deleted: boolean;
    roles: string;
    branch: string;
}

export const useFilters = () => {
	const dispatch = useDispatch();

    const [filters, setFilters] = useState<Filters>({
        enabled: true,
        deleted: false,
        roles: "",
        branch: "",
    });

    const [showSearch, setShowSearch] = useState<boolean>(false);
    const [defaultCheckedItemsActive, setDefaultCheckedItemsActive] = useState<ListDropdownMultipleProps[]>([]);
    const [defaultCheckedItemsRol, setDefaultCheckedItemsRol] = useState<ListDropdownMultipleProps[]>([]);
    const [defaultCheckedItemsBranch, setDefaultCheckedItemsBranch] = useState<ListDropdownMultipleProps[]>([]);


    const handleRolFilter = (item: ListDropdownMultipleProps | ListDropdownMultipleProps[]) => {
        setFilters({ ...filters, roles: (item as ListDropdownMultipleProps).id as string });
        setDefaultCheckedItemsRol([item] as ListDropdownMultipleProps[]);
        loadUsersByFilters(filters.enabled);
    }

    const handleBranchFilter = (item: ListDropdownMultipleProps | ListDropdownMultipleProps[]) => {
        setFilters({ ...filters, branch: (item as ListDropdownMultipleProps).id as string });
        setDefaultCheckedItemsBranch([item] as ListDropdownMultipleProps[]);
        loadUsersByFilters(filters.enabled);
    }

    const handleActiveFilter = (item: ListDropdownMultipleProps | ListDropdownMultipleProps[]) => {
        const value = (item as ListDropdownMultipleProps).id === "true";
        setFilters({ ...filters, enabled: value });
        setDefaultCheckedItemsActive([item] as ListDropdownMultipleProps[]);
        loadUsersByFilters(value);
    }
    
    const clearFilters = () => {
        setFilters({ ...filters, roles: "", branch: "", enabled: true });
        setDefaultCheckedItemsRol([]);
        setDefaultCheckedItemsBranch([]);
        setDefaultCheckedItemsActive([]);
        loadUsersByFilters(true);
    }

    const handleShowSearch = () => {
        setShowSearch(!showSearch);
    }

    const loadUsersByFilters = (status: boolean) => {
        console.log("filters", filters);
        dispatch(
            user({
              orderBy: "createdAt",
              orderDir: "desc",
              enabled: status,
              page: 1,
              limit: 20,
              deleted: false,
              roles: filters.roles,
              branch: filters.branch,
            }),
          );
    }

    return {    
        handleRolFilter,
        handleBranchFilter,
        defaultCheckedItemsRol,
        defaultCheckedItemsBranch,
        handleActiveFilter,
        defaultCheckedItemsActive,
        clearFilters,
        showSearch,
        setShowSearch,
        handleShowSearch
    }
}
